<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
          data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
          class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
            <div v-for="(bread, key) in breadcrumbs" :key="key">
              <li class="breadcrumb-item text-muted" v-if="key + 1 !== breadcrumbs.length">
                <router-link :to="bread.path" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
              </li>
              <li v-else class="breadcrumb-item text-dark">{{ $t(bread.name) }}</li>
            </div>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <div class="m-0">
            <select name="filter" style="width:250px!important;" v-model="shop_selected" data-control="select2"
              data-search="true" data-placeholder="Filter"
              class="form-select kt_select_user form-select-sm border-primary w-200px me-5">
              <option :value="'all'" selected>{{ $t('dashboard.all_shop') }}</option>
              <option v-if="$hasModule('ecommerce')" :value="'ecommerce'">{{ $t('dashboard.ecommerce') }}</option>
              <option v-for="filter in shops" :value="filter.id" :key="filter.id">{{ filter.name }}</option>
            </select>
          </div>
          <div class="card-toolbar">
            <div dashboard-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
              class="btn btn-sm btn-light d-flex align-items-center px-4">
              <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
              <span class="svg-icon svg-icon-1 ms-2 me-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"/>
                  <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"/>
                  <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div v-show="isReady" id="kt_content_container" class="container-xxl">

        <!-- KPI Cards -->
        <div class="d-flex gap-5 flex-wrap mb-8">

          <!-- Total contacts -->
          <div class="kpi-card flex-grow-1" style="min-width:200px">
            <div class="kpi-icon-box" style="background:rgba(0,158,247,0.1)">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" fill="#009EF7"/>
                <path opacity="0.3" d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" fill="#009EF7"/>
              </svg>
            </div>
            <div class="flex-grow-1">
              <div class="kpi-big-number">{{ userStats.total_contacts ?? 0 }}</div>
              <div class="text-gray-500 fw-semibold fs-6">{{ $t('dashboard.customers') }}</div>
            </div>
          </div>

          <!-- Clients ayant acheté -->
          <div class="kpi-card flex-grow-1" style="min-width:200px">
            <div class="kpi-icon-box" style="background:rgba(80,205,137,0.1)">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="#50CD89"/>
                <path d="M7 12L10 15L17 9" stroke="#50CD89" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="flex-grow-1">
              <div class="kpi-big-number">{{ userStats.total_customers ?? 0 }}</div>
              <div class="text-gray-500 fw-semibold fs-6">{{ $t('dashboard.customers_buy') }}</div>
            </div>
          </div>

          <!-- CA -->
          <div class="kpi-card flex-grow-1" style="min-width:200px">
            <div class="kpi-icon-box" style="background:rgba(114,57,234,0.1)">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="#7239EA"/>
                <path d="M14.5 7H9.5C8.67157 7 8 7.67157 8 8.5C8 9.32843 8.67157 10 9.5 10H14.5C15.3284 10 16 9.32843 16 8.5C16 7.67157 15.3284 7 14.5 7Z" fill="#7239EA"/>
                <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14H9.5C8.67157 14 8 13.3284 8 12.5C8 11.6716 8.67157 11 9.5 11H14.5C15.3284 11 16 11.6716 16 12.5C16 13.3284 15.3284 14 14.5 14H13V17Z" fill="#7239EA"/>
              </svg>
            </div>
            <div class="flex-grow-1">
              <div class="kpi-big-number">
                {{ turnover }} <small class="fs-5 fw-normal text-muted">{{ currency }}</small>
              </div>
              <div class="text-gray-500 fw-semibold fs-6">{{ $t('dashboard.turnover') }}</div>
            </div>
          </div>

        </div>

        <!-- Top clients CA — pleine largeur -->
        <div class="row gy-5 g-xl-8 mb-5">
          <div class="col-12">
            <div class="card dashboard-card">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(255,199,0,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#FFC700"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.top5salecustomer') }}</div>
                    <div class="fs-7 text-muted fw-semibold">Clients avec le plus de ventes</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="!userStats?.top_customers?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <template v-else>
                  <!-- Mobile : leaderboard -->
                  <div v-if="isMobile" class="client-leaderboard">
                    <div
                      v-for="(c, i) in userStats.top_customers"
                      :key="i"
                      class="leaderboard-row"
                      :class="i === 0 ? 'leaderboard-row--gold' : i === 1 ? 'leaderboard-row--silver' : i === 2 ? 'leaderboard-row--bronze' : ''"
                    >
                      <div class="leaderboard-rank">
                        <span v-if="i === 0">🥇</span>
                        <span v-else-if="i === 1">🥈</span>
                        <span v-else-if="i === 2">🥉</span>
                        <span v-else class="leaderboard-rank-num">{{ i + 1 }}</span>
                      </div>
                      <div class="leaderboard-avatar" :style="{ background: customerAvatarColor(i) }">
                        {{ customerInitials(c.customer_firstname, c.customer_lastname) }}
                      </div>
                      <div class="leaderboard-info">
                        <div class="leaderboard-name-wrap">{{ c.customer_firstname }} {{ c.customer_lastname }}</div>
                        <div class="leaderboard-amount-below">
                          {{ $formatLocalAmount(c.total_sales) }}<small>{{ currency }}</small>
                        </div>
                        <div class="leaderboard-bar">
                          <div class="leaderboard-bar-fill"
                            :style="{ width: Math.round(c.total_sales / (userStats.top_customers[0]?.total_sales || 1) * 100) + '%' }">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Desktop : tableau classement pleine largeur -->
                  <div v-else class="top-customers-table">
                    <div class="tct-header">
                      <span>#</span><span>Client</span><span>Chiffre d'affaires</span><span>Part</span><span class="tct-bar-col">Progression</span>
                    </div>
                    <div v-for="(c, i) in userStats.top_customers" :key="i" class="tct-row">
                      <div class="tct-rank">
                        <span v-if="i === 0">🥇</span>
                        <span v-else-if="i === 1">🥈</span>
                        <span v-else-if="i === 2">🥉</span>
                        <span v-else class="tct-rank-num">{{ i + 1 }}</span>
                      </div>
                      <div class="tct-client">
                        <div class="tct-avatar" :style="{ background: customerAvatarColor(i) }">{{ customerInitials(c.customer_firstname, c.customer_lastname) }}</div>
                        <span class="tct-name">{{ c.customer_firstname }} {{ c.customer_lastname }}</span>
                      </div>
                      <div class="tct-amount">{{ $formatLocalAmount(c.total_sales) }} <small>{{ currency }}</small></div>
                      <div class="tct-percent">{{ totalTopCustomers > 0 ? ((c.total_sales / totalTopCustomers) * 100).toFixed(1) + '%' : '—' }}</div>
                      <div class="tct-bar-col">
                        <div class="tct-bar">
                          <div class="tct-bar-fill" :style="{ width: totalTopCustomers > 0 ? ((c.total_sales / totalTopCustomers) * 100).toFixed(1) + '%' : '0%', background: tctBarColor(i) }"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 1 : Fréquence + Panier moyen -->
        <div class="row gy-5 g-xl-8 mb-5">

          <!-- Fréquence de visites -->
          <div class="col-lg-6">
            <div class="card dashboard-card h-100">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(0,158,247,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M2 13H10V21H2V13ZM14 5H22V21H14V5Z" fill="#009EF7"/>
                      <path d="M2 3H10V12H2V3ZM14 3H22V4H14V3Z" fill="#009EF7"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.frequence') }}</div>
                    <div class="fs-7 text-muted fw-semibold">Nombre de visites par client</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="!userStats?.customer_visits?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else id="customer_visits" style="height:320px"></div>
              </div>
            </div>
          </div>

          <!-- Panier moyen -->
          <div class="col-lg-6">
            <div class="card dashboard-card h-100">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(80,205,137,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <rect x="2" y="14" width="4" height="8" rx="1" fill="#50CD89"/>
                      <rect x="8" y="9" width="4" height="13" rx="1" fill="#50CD89" opacity="0.7"/>
                      <rect x="14" y="5" width="4" height="17" rx="1" fill="#50CD89" opacity="0.5"/>
                      <rect x="20" y="2" width="4" height="20" rx="1" fill="#50CD89" opacity="0.3"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.moyenne') }}</div>
                    <div class="fs-7 text-muted fw-semibold">Panier moyen par client</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="!userStats?.average_purchase_amount?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else id="average_purchase_amount" style="height:320px"></div>
              </div>
            </div>
          </div>

        </div>


      </div>

      <!-- Loader -->
      <div class="container-xxl" v-show="!isReady">
        <Loader text="Loading..." />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  components: { Loader },
  data() {
    return {
      title: "navigation.statistique",
      breadcrumbs: [
        { name: 'navigation.customers', path: '/admin' },
      ],
      startDate: null,
      endDate: null,
      shops: [],
      shop_selected: 'all',
      turnover: 0,
      turnoverTotal: 0,
      currency: '',
      userStats: {},
      isReady: false,
      iso: '',
      customerVisitsChart: null,
      averagePurchaseChart: null,
      topCustomersChart: null,
      isMobile: window.innerWidth <= 767,
    }
  },

  watch: {
    '$i18n.locale': function (value) {
      if (value) {
        this.$nextTick(() => this.initDateRange())
      }
    },
    shop_selected: async function (value) {
      if (value) {
        this.isReady = false
        await this.drawCharts()
      }
    },
  },

  beforeUnmount() {
    window.removeEventListener('resize', this._onResize)
  },

  async mounted() {
    window.addEventListener('resize', this._onResize = () => {
      this.isMobile = window.innerWidth <= 767
    })
    this.isReady = false
    KTApp.initSelect2()
    // loadUserShops() doit résoudre AVANT initSelect() : voir le commentaire
    // équivalent dans Category.vue (select2 fige la liste d'options à son
    // init, les <option v-for> n'existent pas encore tant que shops est vide).
    await this.loadUserShops()
    if (this.shops && this.shops.length) {
      this.shop_selected = 'all'
    }
    await this.initSelect()
    await this.initDateRange()
    let response = await this.getCurrency()
    this.iso = response?.data?.currency_symbol
    this.currency = response.data?.currency_symbol ?? response.data?.symbol_native
  },

  computed: {
    totalTopCustomers() {
      return (this.userStats?.top_customers || []).reduce((sum, c) => sum + parseFloat(c.total_sales || 0), 0)
    },
  },

  methods: {
    customerInitials(firstname, lastname) {
      const f = firstname?.[0] ?? ''
      const l = lastname?.[0] ?? ''
      return (f + l).toUpperCase() || '?'
    },
    customerAvatarColor(i) {
      const colors = ['#3699FF22','#50CD8922','#FFC70022','#F1416C22','#7239EA22','#0b3d8722']
      return colors[i % colors.length]
    },
    tctBarColor(i) {
      const colors = ['#3699FF','#50CD89','#FFC700','#F1416C','#7239EA','#0b3d87']
      return colors[i % colors.length]
    },
    ...mapActions('shop', ['getCurrency']),

    async initSelect() {
      // Voir le commentaire équivalent dans Category.vue : select2 recopie
      // toujours les classes du <select> sur son <span> généré, il faut donc
      // qualifier par balise ("select.xxx") pour n'attraper que le vrai
      // <select> — sinon select2 s'initialise aussi sur le <span> et la
      // sélection ne se committe jamais.
      let kt_select = $('body select.kt_select_user')
      kt_select.select2()
      kt_select.change((e) => {
        if (e.target.name === 'filter') {
          this.shop_selected = e.target.value
        }
      })
    },

    async loadUserShops() {
      await axios.get(`/dashboard/shops`)
        .then((response) => { this.shops = response.data.shops })
        .catch((error) => { console.log(error) })
    },

    async loadUserStats() {
      if (this.shop_selected && this.startDate && this.endDate) {
        await axios.get(`/dashboard/statistics/user?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
          .then((response) => { this.userStats = response.data })
          .catch((error) => { console.log(error) })
      }
    },

    drawCustomerVisits() {
      if (this.customerVisitsChart) this.customerVisitsChart.destroy()
      const el = document.querySelector('#customer_visits')
      if (!el) return

      const categories = this.userStats.customer_visits.map(i => `${i.customer_lastname || ''} ${i.customer_firstname || ''}`.trim())
      const values = this.userStats.customer_visits.map(i => i.visit_count)
      const borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color')

      this.customerVisitsChart = new ApexCharts(el, {
        series: [{ name: i18n.global.t('statistics.frequence'), data: values }],
        chart: { fontFamily: 'inherit', type: 'bar', height: 320, toolbar: { show: false } },
        plotOptions: {
          bar: { horizontal: false, columnWidth: '40%', borderRadius: 5, dataLabels: { position: 'top' } }
        },
        dataLabels: {
          enabled: true,
          offsetY: -22,
          style: { fontSize: '12px', colors: [KTUtil.getCssVariableValue('--bs-gray-700')] }
        },
        legend: { show: false },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories,
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: { style: { colors: KTUtil.getCssVariableValue('--bs-gray-500'), fontSize: '12px' } }
        },
        yaxis: {
          labels: { style: { colors: KTUtil.getCssVariableValue('--bs-gray-500'), fontSize: '12px' } }
        },
        fill: { opacity: 1 },
        tooltip: { style: { fontSize: '12px' } },
        colors: [KTUtil.getCssVariableValue('--bs-info')],
        grid: { borderColor, strokeDashArray: 4, yaxis: { lines: { show: true } } }
      })
      this.customerVisitsChart.render()
    },

    drawAveragePurchaseAmount() {
      if (this.averagePurchaseChart) this.averagePurchaseChart.destroy()
      const el = document.querySelector('#average_purchase_amount')
      if (!el) return

      const categories = this.userStats.average_purchase_amount.map(i => `${i.customer_lastname || ''} ${i.customer_firstname || ''}`.trim())
      const values = this.userStats.average_purchase_amount.map(i => parseFloat(i.average_purchase_amount).toFixed(2))
      const borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color')

      this.averagePurchaseChart = new ApexCharts(el, {
        series: [{ name: i18n.global.t('statistics.moyenne'), data: values }],
        chart: { fontFamily: 'inherit', type: 'bar', height: 320, toolbar: { show: false } },
        plotOptions: {
          bar: { horizontal: false, columnWidth: '40%', borderRadius: 5, dataLabels: { position: 'top' } }
        },
        dataLabels: {
          enabled: true,
          offsetY: -22,
          style: { fontSize: '12px', colors: [KTUtil.getCssVariableValue('--bs-gray-700')] }
        },
        legend: { show: false },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories,
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: { style: { colors: KTUtil.getCssVariableValue('--bs-gray-500'), fontSize: '12px' } }
        },
        yaxis: {
          labels: { style: { colors: KTUtil.getCssVariableValue('--bs-gray-500'), fontSize: '12px' } }
        },
        fill: { opacity: 1 },
        tooltip: { style: { fontSize: '12px' } },
        colors: [KTUtil.getCssVariableValue('--bs-primary')],
        grid: { borderColor, strokeDashArray: 4, yaxis: { lines: { show: true } } }
      })
      this.averagePurchaseChart.render()
    },

    drawTopCustomers() {
      if (this.topCustomersChart) this.topCustomersChart.destroy()
      const el = document.querySelector('#top_customers')
      if (!el || !this.userStats.top_customers?.length) return

      const labels = this.userStats.top_customers.map(i => `${i.customer_lastname || ''} ${i.customer_firstname || ''}`.trim())
      const values = this.userStats.top_customers.map(i => parseFloat(i.total_sales))

      this.topCustomersChart = new ApexCharts(el, {
        series: values,
        labels,
        chart: { fontFamily: 'inherit', type: 'donut', height: 320 },
        colors: ['#4e73df', '#1cc88a', '#36b9cc', '#f6c23e', '#e74a3b'],
        legend: { position: 'bottom', fontSize: '13px' },
        dataLabels: { enabled: true },
        plotOptions: {
          pie: { donut: { size: '65%', labels: { show: true, total: { show: true, label: 'Total' } } } }
        },
        tooltip: {
          y: { formatter: (val) => this.$formatLocalAmount(val) + ' ' + this.iso }
        }
      })
      this.topCustomersChart.render()
    },

    async drawCharts() {
      this.isReady = false
      await this.loadStaticsCount()
      await this.loadUserStats()
      this.$nextTick(() => {
        this.drawCustomerVisits()
        this.drawAveragePurchaseAmount()
        this.drawTopCustomers()
      })
      this.isReady = true
    },

    async loadStaticsCount() {
      if (this.shop_selected && this.startDate && this.endDate) {
        await axios.get(`/dashboard/statistics/count?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
          .then((response) => {
            this.turnover = this.$formatLocalAmount(response.data.turnover)
            this.turnoverTotal = response.data.turnoverTotal
            this.currency = response.data.currency
          })
          .catch(() => {})
      }
    },

    async initDateRange() {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]')
      let start = moment().subtract(29, 'days')
      let end = moment()

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'), i18n.global.t('lu'), i18n.global.t('ma'), i18n.global.t('me'), i18n.global.t('je'), i18n.global.t('ve'), i18n.global.t('sa')],
          monthNames: [
            i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'),
            i18n.global.t('april'), i18n.global.t('may'), i18n.global.t('june'),
            i18n.global.t('july'), i18n.global.t('august'), i18n.global.t('september'),
            i18n.global.t('october'), i18n.global.t('november'), i18n.global.t('december')
          ],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      }, this.cb)

      this.cb(start, end)
    },

    async cb(start, end) {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]')
      let display = element.querySelector('div')
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY')
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')
      if (this.startDate && this.endDate) {
        await this.drawCharts()
      }
    },
  }
}
</script>

<style scoped>
/* ── Leaderboard mobile ── */
.client-leaderboard { display: flex; flex-direction: column; gap: 8px; }
.leaderboard-row {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 12px; border-radius: 10px;
  background: #f9f9f9; border: 1px solid #e4e6ef;
}
.leaderboard-row--gold   { background: #fffbea; border-color: #ffc700; }
.leaderboard-row--silver { background: #f4f4f4; border-color: #c0c0c0; }
.leaderboard-row--bronze { background: #fff5f0; border-color: #cd7f32; }
.leaderboard-rank { font-size: 1.3rem; width: 28px; flex-shrink: 0; text-align: center; }
.leaderboard-rank-num { font-size: 0.85rem; font-weight: 700; color: #a1a5b7; }
.leaderboard-avatar {
  width: 38px; height: 38px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem; font-weight: 700; color: #3f4254;
  flex-shrink: 0; border: 1px solid rgba(0,0,0,0.06);
}
.leaderboard-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 5px; }
.leaderboard-name-wrap { font-size: 0.85rem; font-weight: 600; color: #1e2130; word-break: break-word; line-height: 1.3; }
.leaderboard-amount-below { font-size: 0.9rem; font-weight: 700; color: #0b3d87; }
.leaderboard-amount-below small { font-size: 0.68rem; font-weight: 500; color: #a1a5b7; margin-left: 2px; }
.leaderboard-bar { height: 4px; background: #e4e6ef; border-radius: 2px; overflow: hidden; }
.leaderboard-bar-fill { height: 100%; border-radius: 2px; transition: width 0.4s ease; background: linear-gradient(90deg, #50CD89, #3699FF); }

/* ── Tableau classement desktop ── */
.top-customers-table {
  border-radius: 10px;
  border: 1px solid #e4e6ef;
  overflow: hidden;
}

.tct-header,
.tct-row {
  display: grid;
  grid-template-columns: 40px 1fr 160px 70px 180px;
  align-items: center;
  padding: 10px 16px;
  gap: 12px;
}

.tct-header {
  background: #f5f5f5;
  font-size: 0.72rem;
  font-weight: 700;
  color: #a1a5b7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e4e6ef;
}

.tct-row {
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.1s;
}
.tct-row:last-child { border-bottom: none; }
.tct-row:hover { background: #fafafa; }

.tct-rank { font-size: 1.2rem; text-align: center; }
.tct-rank-num { font-size: 0.85rem; font-weight: 700; color: #a1a5b7; }

.tct-client {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.tct-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 700;
  color: #3f4254;
  flex-shrink: 0;
  border: 1px solid rgba(0,0,0,0.06);
}

.tct-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #1e2130;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tct-amount {
  font-size: 0.88rem;
  font-weight: 700;
  color: #1e2130;
  white-space: nowrap;
}
.tct-amount small { font-size: 0.68rem; font-weight: 500; color: #a1a5b7; margin-left: 2px; }

.tct-percent {
  font-size: 0.82rem;
  font-weight: 600;
  color: #5e6278;
  text-align: center;
}

.tct-bar-col { min-width: 0; }
.tct-bar {
  height: 8px;
  background: #e4e6ef;
  border-radius: 4px;
  overflow: hidden;
}
.tct-bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.5s ease;
}

.kpi-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  overflow: hidden;
}

.kpi-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #009EF7, #7239EA);
  border-radius: 12px 12px 0 0;
}

.kpi-icon-box {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kpi-big-number {
  font-size: 1.75rem;
  font-weight: 700;
  color: #181c32;
  line-height: 1.2;
  margin-bottom: 4px;
}

.dashboard-card {
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  border: none;
}

.section-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

</style>
